module.exports = function getResource(label, vars = []) {
    let resources = {
        biTermsAndConditions: 'Beauty Insider Terms and Conditions',
        termsAndConditions: 'Terms and conditions',
        required: '(required)'
    };

    return resources[label];
};
